import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { TypeOverride } from '../../../abelcommon';
import { UserMiningInfo, env } from '../../../api';
import { LatestAllocateHistorySection } from './LatestAllocateHistorySection';
import { OverviewSection } from './OverviewSection';
import { PayoutHistorySection } from './PayoutHistorySection';
import { PendingListSection } from './PendingListSection';
import { useTranslation } from 'react-i18next';

export type OverridedUserMiningInfo = TypeOverride<
  UserMiningInfo,
  { balance: number | null; userShareCount: number; totalShareCount: number }
>;

export const RewardPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = env.title + ` | ${t('overviewSectionPage.reward')}`;
  }, [t]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <OverviewSection />
      </Grid>
      <Grid item xs={12}>
        <PendingListSection />
      </Grid>
      <Grid item xs={12}>
        <PayoutHistorySection />
      </Grid>
      <Grid item xs={12}>
        <LatestAllocateHistorySection />
      </Grid>
    </Grid>
  );
};
